exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n/** Button按钮间距 */\n.ant-btn[data-v-131ef3f5] {\n  margin-left: 8px\n}\n", ""]);

// exports
